import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Hide = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.25 9.74c-2.592-4.542-7.267-6.05-11.267-4.575L8.358 6.54a3.896 3.896 0 0 1 1.65-.375 3.909 3.909 0 0 1 3.909 3.908c0 .592-.142 1.15-.375 1.65l1.916 1.917c1.067-.817 2.025-1.892 2.792-3.234a.678.678 0 0 0 0-.666ZM10.008 13.982A3.909 3.909 0 0 1 6.1 10.073c0-.592.142-1.142.375-1.642L4.55 6.506A10.857 10.857 0 0 0 1.767 9.74a.663.663 0 0 0 0 .658c2.575 4.542 7.25 6.05 11.258 4.575l-1.375-1.375c-.5.233-1.05.375-1.642.375v.008Z" />
      <Path d="M10 7.356c-.25 0-.492.042-.717.109l3.325 3.325c.067-.233.109-.467.109-.717 0-1.5-1.217-2.717-2.717-2.717ZM10.717 12.681 7.392 9.357a2.572 2.572 0 0 0-.109.717c0 1.5 1.217 2.717 2.717 2.717.25 0 .492-.042.717-.108ZM4.525 3.765a.669.669 0 0 0-.942 0 .669.669 0 0 0 0 .941L15.367 16.49c.133.133.3.192.475.192a.69.69 0 0 0 .475-.192.67.67 0 0 0 0-.942L4.525 3.765Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" transform="translate(0 .073)" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Hide
